import React from "react";

const EditingBookingSummary = ({ videoPackages = [] }) => (
    <div className="editing-booking-summary">
        <h4 className="editing-booking-summary__title">Editing Booking Summary</h4>

        <div className="editing-booking-summary__cards">
            {videoPackages
                .filter((pkg) => (pkg.videosCount || 0) > 0 || pkg.price > 0 || true)
                .map((pkg, index) => {
                    const subTotal = pkg.price || 0;
                    let displayType = (pkg.type || pkg.planCategory || "").toString().trim();
                    displayType =
                        displayType.charAt(0).toUpperCase() + displayType.slice(1);
                    if (!displayType) displayType = "Standard";

                    return (
                        <div key={index} className="editing-summary-card">
                            <div className="editing-summary-card__top">
                                <span className="editing-summary-card__badge">
                                    {displayType}
                                </span>
                                <span className="editing-summary-card__videos">
                                    {pkg.videosCount ?? 0} Videos
                                </span>
                            </div>
                            <div className="editing-summary-card__price">
                                Price: ₹{subTotal.toLocaleString("en-IN")}
                            </div>
                        </div>
                    );
                })}
        </div>
    </div>
);

export default EditingBookingSummary;
